import React from 'react';
import PropTypes from 'prop-types';
import {css} from "@emotion/css";
import Dialog from "@material-ui/core/Dialog";
import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogActions from "@material-ui/core/DialogActions";
import {Typography} from "@material-ui/core";


const DefaultDialogPage = ({
                               onClose,
                               open,
                               dialogSize = DialogSize.MEDIUM,
                               children,
                               pageTitle
                           }) => {

    const handleClose = () => {
        onClose();
    };

    //Dialog-start
    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });
    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    const DialogActions = withStyles((theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(1),
        },
    }))(MuiDialogActions);
    //Dialog-end


    return (
        <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} id={dialogSize}>
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                <span className={css`flex-grow: 1;`}>{pageTitle}</span>

            </DialogTitle>
            <section className={css`display: flex;
              flex-direction: column;
              flex-grow: 1;
            `}>
                {children}
            </section>
        </Dialog>
    );
}

export default DefaultDialogPage;

DefaultDialogPage.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export const DialogSize = {
    Full: "FullScreenDialogSize",
    LARGE: "LargeDialogSize",
    MEDIUM: "MediumDialogSize",
    SMALL: "SmallDialogSize",
    WRAP_CONTENT: "WrapContentDialogSize",
}